export default __webpack_public_path__ + "static/media/soluciones__6.4f5012a4.jpg";